import { isVodacomVersion } from "../../../constants/gaming";
import Directory from "./Directory";
import ServiceSelectionOld from "./ServiceSelectionOld";

const LaunchPad: React.FC = () => {
  return isVodacomVersion ? <Directory /> : <ServiceSelectionOld />;
};

export default LaunchPad;
